import api from 'utils/api';
import {
  SkuDropdownDTO,
  SkuSlaCreateParams,
  SkuSlaDTO,
  SkuSlaBuyerConfigDTO,
  SkuSlaSupplierConfigDTO,
} from '../domains/slaDomain';
const slaService = {
  getSupplierOrgId: async () => {
    return api.get<number[]>('/api/sla/supplier-org-ids');
  },
  getSkuOptions: async () => {
    return api.get<SkuDropdownDTO[]>('/api/sla/sku-dropdown');
  },
  getSlaListByOrgId: async (supplierOrgId: number) => {
    return api.get<SkuSlaDTO[]>(`/api/sla?supplierOrgId=${supplierOrgId}`);
  },
  getSla: async (id: number) => {
    return api.get<SkuSlaDTO>(`/api/sla/${id}`);
  },
  createSla: async (data: SkuSlaCreateParams) => {
    return api.post<SkuSlaDTO>('/api/sla', data);
  },
  updateSlaBuyer: async (id: number, data: SkuSlaBuyerConfigDTO) => {
    return api.put<SkuSlaDTO>(`/api/sla/${id}/buyer-config`, data);
  },
  updateSlaSupplier: async (id: number, data: SkuSlaSupplierConfigDTO) => {
    return api.put<SkuSlaDTO>(`/api/sla/${id}/supplier-config`, data);
  },
  updateSlaSku: async (id: number, skuId: number) => {
    return api.put<SkuSlaDTO>(`/api/sla/${id}/sku`, { skuId });
  },
  deleteSla: async (id: number) => {
    return api.delete(`/api/sla/${id}`);
  },
};

export default slaService;
